import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import type { ReadOnlyInputActionOptions } from '../../baseDealActivity/baseDealContainer/useReadOnlyInputAction';
import { useReadOnlyInputAction } from '../../baseDealActivity/baseDealContainer/useReadOnlyInputAction';
import { ReadOnlyValue } from '../ScenarioGrid.style';
import { RowLabelAction } from './RowLabelAction';
import { ScenarioRow } from './ScenarioRow';

type ReadOnlyLinkRowProps = ReadOnlyInputActionOptions & {
    rowKey: ScenarioGridRowKey;
    label: string;
    value: string;
};

export const ReadOnlyLinkRow = ({ rowKey, label, value, tab, type = 'amount', onClick }: ReadOnlyLinkRowProps) => {
    const { entityName, isClickable, activate } = useReadOnlyInputAction({ tab, type, onClick });
    const labelText = entityName ? (
        <ActionWithErrorBadge entityName={entityName} xOffset="-2px" yOffset="1px">
            {label}
        </ActionWithErrorBadge>
    ) : (
        label
    );

    return (
        <ScenarioRow
            rowKey={rowKey}
            label={
                isClickable ? (
                    <RowLabelAction onActivate={activate} testId={`${label}-label`}>
                        {labelText}
                    </RowLabelAction>
                ) : (
                    labelText
                )
            }
        >
            <ReadOnlyValue data-testid={label}>{type === 'amount' ? `$${value}` : value}</ReadOnlyValue>
        </ScenarioRow>
    );
};
